import { apiSlice } from '@/api';
import {
  ForgotFields,
  LoginFields,
  RegisterFields,
  ResetFields,
} from '@/models/auth/types';

// TODO: organize better LoginResponse typings

type LoginResponse = {
  accessToken?: string;
  refreshToken?: string;
  data?: {
    code: number;
    error: boolean;
    message: string;
    statusCode: number;
  };
};

// TODO: register remove any type

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<{ result: LoginResponse }, LoginFields>({
      query: (credentials) => ({
        url: 'v1/user/auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    register: builder.mutation<any, RegisterFields>({
      query: (credentials) => ({
        url: 'v1/user/auth/register',
        method: 'POST',
        body: credentials,
      }),
    }),
    activate: builder.query<any, string>({
      query: (token) => ({
        url: `v1/user/auth/activate-account?token=${token}`,
        method: 'GET',
      }),
    }),
    forgot: builder.mutation<any, ForgotFields>({
      query: (credentials) => ({
        url: `v1/user/auth/forgot-password`,
        method: 'POST',
        body: credentials,
      }),
    }),
    resetPassword: builder.mutation<any, ResetFields>({
      query: (credentials) => ({
        url: `v1/user/auth/reset-password`,
        method: 'PATCH',
        body: credentials,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useActivateQuery,
  useForgotMutation,
  useResetPasswordMutation,
} = authApiSlice;
